const projects = [
    {
        id: 1,
        "title": "html5",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/html5.svg",

        "content": [
            "You will master fundamentals of HTML, CSS, and JavaScript first to be able to confidently dive into more complex coding challenges.",
            "Structure beautiful layouts for modern websites and utlilize the full-feature set of HTML5.",
            "Used to create mobile-friendly games.",
        ],
    },
    {
        id: 2,
        "title": "css3",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/css3-alt.svg",

        "content": [
            "Learn to use CSS3 before moving on to utilizing CSS frameworks.",
            "With increasing support from major browsers, developers can start efficiently utilizing CSS3 to render elegantly on any device – desktop, phone, or tablet",
            "Used to increase expressive style.",
        ],
    },
    {
        id: 3,
        "title": "javascript",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/js.svg",

        "content": [
            "Learn the world’s most utilized programming langauge to increase graphical user interfaces and interactivity of websites on the front-end.",
            "You will Learn from basic to advance JS in this course.",
            "Root level and advance javaScript.",
        ],
    },
    {
        id: 4,
        "title": "jquery",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/js.svg",

        "content": [
            "Simplify programming with JavaScript with the large, easy-to-use jQuery library, and popular API’s.",
            "Used for traversing DOM.",
        ],
    },
    {
        id: 5,
        "title": "react",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/react.svg",

        "content": [
            "Learn one of the fastest growing frameworks in today's market",
            "React makes it painless to create interactive UIs.",
            "Design simple views for each state in your application, and React will efficiently update and render just the right components when your data changes.",
        ],
    },
    {
        id: 6,
        "title": "firebase",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/google-drive.svg",

        "content": [
            "Firebase powers your app’s backend, including data storage, user authentication, static hosting, and more!",
            "Build cross-platform native mobile and web apps with our Android, iOS, and JavaScript SDKs.",
            "Lightning-fast data synchronization.",
        ],
    },
    {
        id: 7,
        "title": "nodejs",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/node.svg",

        "content": [
            "Node.js is a platform for easily building fast and scalable network applications such as a web server.",
            "You will learn how to create lightweight applications with real time communication.",
            "JavaScript is the most commonly used programming language on earth. Node.js brings JavaScript to the back-end (server side).",
        ],
    },
    {
        id: 8,
        "title": "github workflow",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/github.svg",

        "content": [
            "The entire curriculum is built into GitHub and we have intentionally structured it to be a part of the learning process and how we deliver our training methodologies for best results.",
            "GitHub is crucial for modern developers to code in an efficient/professional workflow.",
        ],
    },
    {
        id: 9,
        "title": "git",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/git.svg",

        "content": [
            "Git is a free and open source distributed version control system designed to handle everything from small to very large projects with speed and efficiency.",
            "You will master GIT and we will using GIT from day one and in all projects."
        ],
    },
    {
        id: 11,
        "title": "webpack",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/codepen.svg",

        "content": [
            "Webpack is a module bundler.",
            "Webpack can take care of bundling alongside a separate task runner. ",
            "In this module you will learn how to bundle you project.",
            "Will learn about webpack plugins"
        ],
    },
    {
        id: 12,
        "title": "fundamental of cs",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/connectdevelop.svg",

        "content": [
            "In the first 2 weeks you will be learning fundamental concepts and strategies.",
            "Best practices in the software engineering industry.",
            "thinking like an engineer.",
        ],
    },
    {
        id: 13,
        "title": "data structures",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/linode.svg",

        "content": [
            "You will learn about the basic data structures used throughout the course.",
            "We will be looking at the Fundamental building blocks of data structures.",
            "Arrays, linked lists etc will be covered.",
        ],
    },
    {
        id: 14,
        "title": "algorithms",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/searchengin.svg",

        "content": [
            "What are algorithms and why should you care? We'll start with an overview of algorithms.",
            "You will be learning the most popular algorithms in this module.",
            "Binary Search, Selection Sort, Insertion, Recursive, Merge, etc",
        ],
    },
    {
        id: 15,
        "title": "bootstrap",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/twitter.svg",

        "content": [
            "You will learn the world most popular framework for building responsive apps.",
            "Mobile-first sites, Desktop only and how to use all building blocks of bootstrap.",
        ],
    },
    {
        id: 16,
        "title": "bulma",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/css3.svg",

        "content": [
            "You will learn the very recent framework based on css3 Flexbox.",
            "100% responsive , Modern, Modular and awesome framework.",
        ],
    },
    {
        id: 17,
        "title": "css3 flexbox",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/buromobelexperte.svg",

        "content": [
            "A new technology, but with support now fairly widespread across browsers, Flexbox is starting to become ready for widespread use. ",
            "Flexbox provides tools to allow rapid creation of complex, flexible layouts, and features that historically proved difficult with CSS.",
        ],
    },
    {
        id: 18,
        "title": "css3 grid system",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/angrycreative.svg",

        "content": [
            "CSS Grid Layout excels at dividing a page into major regions, or defining the relationship in terms of size, position, and layer, between parts of a control built from HTML primitives.",
            "Like tables, grid layout enables an author to align elements into columns and rows. ",
            "many more layouts are either possible or easier with CSS grid than they were with tables.",
        ],
    },
    {
        id: 19,
        "title": "redux",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/rendact.svg",

        "content": [
            "Redux is a predictable state container for JavaScript apps.",
            "Redux borrows many concepts from functional programming. Pure functions, data immutability and higher order functions and currying - to name a few, are deeply ingrained in the library.",
            "You will learn basic concepts of redux."
        ],
    },
    {
        id: 20,
        "title": "advance redux",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/rendact.svg",

        "content": [
            "Will learn advance concepts of redux along with react.",
            "Redux life cycle Actions , Reducers and Store in depth.",
        ],
    },
    {
        id: 21,
        "title": "advance react",
        "icon": "https://use.fontawesome.com/releases/v5.0.9/svgs/brands/react.svg",

        "content": [
            "Learn advance react concepts.",
            "State , props, components, containers in depth.",
            "React life cycle hooks/methods in detail.",
            "React and redux integration.",
        ],
    },

];
export default projects;


// WEBPACK FOOTER //
// ./src/CoursesData.js